/* Submit Shopify's native cart form using unique line keys and server-rendered totals. */
(() => {
  const form = document.getElementById('owl-cart-form');
  if (!form) return;
  const update = document.getElementById('owl-cart-update');
  let submitting = false;
  form.querySelectorAll('[data-cart-step]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => {
      if (submitting) return;
      const input = button.parentElement.querySelector('input');
      input.value = Math.max(0, (Number.parseInt(input.value, 10) || 0) + Number(button.dataset.cartStep));
      form.requestSubmit(update);
    });
  });
  form.addEventListener('submit', event => {
    if (submitting) { event.preventDefault(); return; }
    submitting = true;
    if (event.submitter === update) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.querySelector('.oc-feedback').hidden = false;
      form.querySelectorAll('[data-cart-step], [name="checkout"]').forEach(button => { button.disabled = true; });
      const action = document.createElement('input');
      action.type = 'hidden';
      action.name = 'update';
      action.value = 'Update cart';
      form.append(action);
      HTMLFormElement.prototype.submit.call(form);
    }
  }, true);
  // Restore controls when returning from checkout through the browser's page cache.
  window.addEventListener('pageshow', () => {
    submitting = false;
    form.querySelector('.oc-feedback').hidden = true;
    form.querySelectorAll('[data-cart-step], [name="checkout"]').forEach(button => { button.disabled = false; });
  });
})();
